/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
import styled from "@emotion/styled";
import * as _range from "lodash/range";

const progressDotsContainerStyle = css`
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    @media (max-width: 520px) {
        display: none;
    }
`;

const ProgressDot = styled.div`
    height: 8px;
    width: 8px;
    margin: 4px;
    ${props => !props.highlighted && "opacity: 0.2;"}
    background-color: #EB59AE;
    border-radius: 100%;
`;

const ProgressDots = ({ numberOfDots, highlightedDotIndex }) => (
    <div data-testid="progress-dots" css={progressDotsContainerStyle}>
        {_range(numberOfDots).map(index => (
            <ProgressDot
                key={`dot-${index}`}
                highlighted={index === highlightedDotIndex}
                className={
                    index === highlightedDotIndex
                        ? "highlighted-progress-dot"
                        : "progress-dot"
                }
            />
        ))}
    </div>
);

export default ProgressDots;
